import { PowerPlanEventType } from "@/services/powerPlans/types";
import i18n from "@/i18n";
import moment from "moment";

export const powerPlanEventFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("powerPlanEvent.eventType"),
        formatter: formatType
    },
    {
        key: "timeInterval",
        label: i18n.t("powerPlanEvent.timeInterval")
    },
    {
        key: "fromDate",
        label: i18n.t("common.startDate")
    },
    {
        key: "toDate",
        label: i18n.t("common.endDate")
    },
    {
        key: "actions",
        label: ""
    }
];

function formatType(type: PowerPlanEventType) {
    return i18n.t(`powerPlanEvent.${PowerPlanEventType[type]}`);
}
